import React from 'react';
import PropTypes from 'prop-types';

import ExternalLink from 'components/Widgets/ExternalLink';

export default function Document({
  title, url, iconClassName, iconStyle, onClick,
}) {
  return (
    <ExternalLink
      href={url === '' ? null : url}
      className="w-100 icon-with-text p-2 bg-gray-100 border-0 rounded text-gray-900 text-decoration-none"
      onClick={onClick}
    >
      <div className="icon-bg bg-white" style={{ height: '48px' }}>
        <i
          className="article-icon bg-secondary"
          style={{ minHeight: '48px', minWidth: '48px' }}
        />
      </div>

      <div className="text-content flex-grow-1 text-start">
        <small className="fw-semibold">{title}</small>
      </div>

      <div className="icon-bg bg-white" style={{ height: '48px' }}>
        <i
          className={iconClassName}
          style={{ minHeight: '48px', minWidth: '48px', ...iconStyle }}
        />
      </div>
    </ExternalLink>
  );
}

Document.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  iconClassName: PropTypes.string,
  iconStyle: PropTypes.object,
  onClick: PropTypes.func,
};

Document.defaultProps = {
  iconClassName: '',
  iconStyle: {},
  onClick: () => {},
};
